type HeaderSource = Pick<Headers, 'get'>;

const stripPort = (address: string): string => {
  const bracketed = address.match(/^\[([^\]]+)\](?::\d+)?$/);
  if (bracketed) return bracketed[1];
  const separator = address.lastIndexOf(':');
  return separator > 0 ? address.slice(0, separator) : address;
};

export function resolveClientIp(headers: HeaderSource): string | undefined {
  const viewerAddress = headers.get('cloudfront-viewer-address')?.trim();
  if (viewerAddress) return stripPort(viewerAddress);

  const chain = headers
    .get('x-forwarded-for')
    ?.split(',')
    .map((entry) => entry.trim())
    .filter(Boolean);
  if (chain?.length) return chain[chain.length - 1];

  return headers.get('x-real-ip')?.trim() || undefined;
}

export function signedClientIpHeaders(
  clientIp: string | undefined
): Record<string, string> {
  const secret = process.env.BFF_SHARED_SECRET;
  if (!secret) return {};
  return clientIp
    ? { 'x-client-ip': clientIp, 'x-bff-secret': secret }
    : { 'x-bff-secret': secret };
}

export function bffSecretHeaders(): Record<string, string> {
  const secret = process.env.BFF_SHARED_SECRET;
  return secret ? { 'x-bff-secret': secret } : {};
}
